module.exports = __webpack_public_path__ + "static/media/cambridge_logo.71dd1749.png";